import { Routes } from '@angular/router';

import { networkSegments } from '@advania-cosoftware/wolf-router';

export const networkRoutes: Routes = [
    {
        path: networkSegments.network,
        loadComponent: () => import('./pages/network-tab-page/network-tab.page').then((m) => m.NetworkTabPageComponent),
        children: [
            {
                path: `${networkSegments.networkEquipment}/:networkEquipmentId`,
                loadComponent: () =>
                    import('./pages/network-equipment-page/network-equipment.page').then((m) => m.NetworkEquipmentPage),
            },
            {
                path: networkSegments.networkEquipment,
                loadComponent: () =>
                    import('./pages/network-equipments-page/network-equipments.page').then(
                        (m) => m.NetworkEquipmentsPage,
                    ),
            },
            {
                path: `${networkSegments.communicationLines}/:commLineId`,
                loadComponent: () =>
                    import('./pages/network-communication-line-page/network-communication-line.page').then(
                        (m) => m.NetworkCommunicationLinePage,
                    ),
            },
            {
                path: networkSegments.communicationLines,
                loadComponent: () =>
                    import('./pages/network-communication-lines-page/network-communication-lines.page').then(
                        (m) => m.NetworkCommunicationLinesPage,
                    ),
            },
        ],
    },
];
